const DateNow = Date.now()
const SPLITTED_DATE = new Date(DateNow).toString().split(' ')
export const FORMATTED_DATE = `${SPLITTED_DATE[0]}, ${SPLITTED_DATE[2]} - ${SPLITTED_DATE[1]}, ${SPLITTED_DATE[3]}`

export const consumerEmail = 'sales@jiopay.in'
export const consumerEmailSubject = `Jiopay business partner program -${FORMATTED_DATE}`
